import { useId, useRef } from 'react';
import { Expand, X } from 'lucide-react';
import './marketing-image-first.css';

export interface ProductImageProps {
  src: string;
  width: number;
  height: number;
  alt: string;
  caption: string;
  priority?: boolean;
  mobileSrc?: string;
}
// WHY: real proof must stay readable. Native dialog retains Escape/focus-return
// and exposes the original capture without changing the product output inside it.
export function ProductImage({ src, width, height, alt, caption, priority, mobileSrc }: ProductImageProps) {
  const modal = useRef<HTMLDialogElement>(null);
  const id = useId();
  return <figure className="bol-product-image">
    <button type="button" className="bol-product-image__open" aria-label={`Enlarge: ${alt}`} aria-haspopup="dialog" onClick={() => modal.current?.showModal()}>
      <picture>{mobileSrc ? <source media="(max-width: 620px)" srcSet={mobileSrc} /> : null}<img src={src} width={width} height={height} alt={alt} loading={priority ? 'eager' : 'lazy'} fetchPriority={priority ? 'high' : 'auto'} decoding="async" /></picture>
      <span className="bol-product-image__expand"><Expand size={16} aria-hidden="true" /> Enlarge</span>
    </button>
    <figcaption>{caption}</figcaption>
    <dialog ref={modal} className="bol-image-dialog" aria-labelledby={id} onClick={event => { if (event.target === event.currentTarget) modal.current?.close(); }}>
      <div className="bol-image-dialog__bar"><p id={id}>{caption}</p><button type="button" onClick={() => modal.current?.close()} autoFocus><X size={22} aria-hidden="true" /> Close</button></div>
      <div className="bol-image-dialog__scroll" tabIndex={0} aria-label="Full-size product image; scroll to see all details"><img src={src} width={width} height={height} alt={alt} /></div>
    </dialog>
  </figure>;
}
